


//测试环境互联网访问

// export const CA_APP_ID = "e9b0f4f66d2e41a3ba8c434fa63cc91c";
// export const CA_APP_SECRET = "56B7F22695EE43B482EDCE4850922DA5";
// export const CA_TOKEN_KEY = "CA_TOKEN";

// //组织，人员注册基础地址          
// export const CA_CONFIG_BASEURL = "https://idapiuat.intra.sheca.com/unitrust";
// // 登录认证 文档2的基础地址
// export const CA_LOGIN_BASEURL = "https://unitrust.uat.sheca.com/api";


//正式环境互联网访问
export const CA_APP_ID = "984deb7270a6471dbe16363a264cd5f2";
export const CA_APP_SECRET = "AA4B8ACE977247C186FB203556C10500";
export const CA_TOKEN_KEY = "CA_TOKEN";
//组织，人员注册基础地址          
export const CA_CONFIG_BASEURL = "https://authn.msc.sh.gov.cn/unitrust";
// 登录认证 文档2的基础地址
export const CA_LOGIN_BASEURL =  "https://authn.msc.sh.gov.cn/api";


